module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Bv4hyg/tc-custom/9781507305683.jpg?1733122068150",
      "alt": "This image is the cover for the book Atlas of Extraterrestrial Zones"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Atlas of Extraterrestrial Zones\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("32 unusual and fascinating extraterrestrial encounters that explores the places and portals between our world and theirs, with illustrated maps for each location (Book 2 of the bestselling Atlas series)  Where is the best place to meet kind and peaceful aliens? How do we communicate with intelligent interstellar life forms, socialize with Martians, and avoid unwanted close encounters of the third kind? These and other answers to ET mysteries are captured in the thirty-two stories in the Atlas of Extraterrestrial Zones, where maps direct readers to the portals that open up between the worlds, a geography of strange events that covers the entire earth, demonstrating how widespread the phenomenon is.  Learn about locations of extraterrestrial sightings, hidden bases, secret embassies, and long-lost traces of thousand-year-old passages. From the UFO port of Arès to the underground center of Area 51, from the crash at Roswell to setting up the SETI program, this atlas lists, for the first time, the meeting points between earthlings and these mysterious extraterrestrial biological entities (EBEs).")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bruno Fuligni, François Moreno\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bruno Fuligni is a writer and historian who has written more than 20 books. He lives in France.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Schiffer Publishing, Ltd.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0